module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "top": "5px"
    },
    attrs: {
      "color": "alerts",
      "relative": "",
      "fab": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.createDiag = true
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "primary",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/dashboard.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "primary",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user.name.substr(0, _vm.user.name.indexOf(" "))) + "'s Project Dashboard\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search a project..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "scroll-y",
    attrs: {
      "row": "",
      "wrap": "",
      "id": "scroll-target"
    }
  }, _vm._l((_vm.filteredProjects), function(project, index) {
    return _c('v-flex', _vm._b({
      directives: [{
        name: "scroll",
        rawName: "v-scroll:#scroll-target",
        arg: "#scroll-target"
      }],
      key: project.id
    }, 'v-flex', ( _obj = {}, _obj["xs4"] = true, _obj ), false), [_c('v-card', {
      attrs: {
        "color": "grey lighten-2 pa-4"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.funct(project.id)
        }
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [(project.title.length < 30) ? _c('h1', {
      staticClass: "headline mb-0",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(project.title))]) : _vm._e(), _vm._v(" "), (project.title.length > 30) ? _c('h1', {
      staticClass: "headline mb-0",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(project.title.substring(0, 30)) + "...")]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-badge', {
      attrs: {
        "color": "red",
        "overlap": ""
      }
    }, [(project.unreadMessages > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(project.unreadMessages))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.funct(project.id)
        }
      }
    }, [_vm._v("Open")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
      model: {
        value: (project.projectDialog),
        callback: function($$v) {
          _vm.$set(project, "projectDialog", $$v)
        },
        expression: "project.projectDialog"
      }
    }, [(_vm.$store.getters.user.id === project.creatorID) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("\n            Delete\n          ")]) : _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("Leave")]), _vm._v(" "), (_vm.$store.getters.user.id === project.creatorID) ? _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to delete the Project: " + _vm._s(project.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.deletes(project)
        }
      }
    }, [_vm._v("\n                    Delete\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          project.projectDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1) : _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to leave the Project: " + _vm._s(project.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.leave(project)
        }
      }
    }, [_vm._v("\n                    Leave\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          project.projectDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "500"
      },
      model: {
        value: (_vm.show[index]),
        callback: function($$v) {
          _vm.$set(_vm.show, index, $$v)
        },
        expression: "show[index]"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "6ex",
        "height": "6ex"
      },
      attrs: {
        "slot": "activator",
        "src": "/static/img/official_icons/info.png"
      },
      slot: "activator"
    }), _vm._v(" "), _c('v-card', [_c('v-card-title', {
      staticClass: "headline grey lighten-2",
      attrs: {
        "primary-title": ""
      }
    }, [_vm._v("\n              Details\n            ")]), _vm._v(" "), _c('v-card-text', [_c('div', {
      staticClass: "text-md-center pa-8 ma-4"
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('h1', {
      staticClass: "text-md-center"
    }, [_vm._v("\n                  " + _vm._s(project.title.substring(0).toUpperCase()) + "\n                ")])]), _vm._v(" "), _c('v-card-text', [_c('h2', [_vm._v("Description")]), _vm._v("\n                " + _vm._s(project.description) + "  \n                ")]), _vm._v(" "), (project.startDate !== 0) ? _c('v-card-text', [_c('h2', [_vm._v("Start Date")]), _vm._v("\n                " + _vm._s(_vm.dateFormat(project.startDate)) + "  \n                ")]) : _vm._e(), _vm._v(" "), (project.endDate !== 0) ? _c('v-card-text', [_c('h2', [_vm._v("End Date")]), _vm._v("\n                " + _vm._s(_vm.dateFormat(project.endDate)) + "  \n                ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('h2', [_vm._v("Members")])]), _vm._v(" "), _c('v-list', _vm._l((_vm.members[project.id]), function(member) {
      return _c('v-list-tile', {
        key: member.id + project.id + Math.random(),
        attrs: {
          "avatar": ""
        }
      }, [_c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": member.photoURL
        }
      })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list-tile-action', [(project.creator == member.name) ? _c('div', [_vm._v("\n                        Creator\n                        "), _c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v("star")])], 1) : _vm._e()])], 1)
    }))], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.showInfo(index)
        }
      }
    }, [_vm._v("\n                Close\n              ")])], 1)], 1)], 1)], 1)], 1)])], 1)
    var _obj;
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "width": "1000"
    },
    model: {
      value: (_vm.createDiag),
      callback: function($$v) {
        _vm.createDiag = $$v
      },
      expression: "createDiag"
    }
  }, [_c('v-btn', {
    staticClass: "alerts",
    staticStyle: {
      "right": "75px",
      "bottom": "15px"
    },
    attrs: {
      "slot": "activator",
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "max-height": "8ex"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-project-diag', {
    on: {
      "cancel": function($event) {
        _vm.createDiag = false
      },
      "new": _vm.out
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "right": "150px",
      "bottom": "15px"
    },
    attrs: {
      "absolute": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/calender')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/event2.png"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "right": "225px",
      "bottom": "15px"
    },
    attrs: {
      "absolute": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/profile/' + _vm.$store.getters.user.id)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/profile.png"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d05be4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/ProjectGrid.vue
// module id = 85
// module chunks = 2